import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { Check } from "lucide-react";
import Reveal from "../components/site/Reveal";
import EstimateBar from "../components/site/EstimateBar";
import { CtaLink, LogoTitle } from "../components/site/Common";
import { CityFaq } from "../components/site/CitySeoBlocks";
import { FinalCta } from "../components/site/HomeSections";
import { QUARTIERS, quartierPath, quartierFaq, quartiersOf, pricePath } from "../seoPages";
import { slugify } from "../mock";

export default function QuartierPage() {
  const { slug } = useParams();
  const q = QUARTIERS.find((x) => x.slug === slug);
  if (!q) return <Navigate to="/villes" replace />;
  const others = quartiersOf(q.city).filter((x) => x.slug !== q.slug);
  return (
    <div data-testid="quartier-page" className="bg-gradient-to-b from-[#f3ede1] to-[#faf7f0]">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 lg:pt-24 pb-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <Reveal><Link to={`/villes/${slugify(q.city)}`} className="text-sm font-bold uppercase tracking-[0.2em] text-[#c4703f] hover:underline">Conciergerie {q.city}</Link></Reveal>
          <Reveal delay={80} className="mt-4"><LogoTitle title={`conciergerie ${q.name}`} script={`à ${q.city}`} /></Reveal>
          <Reveal delay={140}><p className="mt-8 text-xl text-[#13261c] leading-relaxed" data-testid="quartier-intro">{q.intro}</p></Reveal>
          <div className="mt-6 space-y-5 text-[17px] text-[#4a5249] leading-relaxed">
            {q.paras.map((p, i) => <Reveal key={i} delay={i * 60}><p>{p}</p></Reveal>)}
          </div>
        </div>
        <Reveal delay={160} className="lg:col-span-5">
          <div className="rounded-[32px] bg-[#13261c] text-[#faf7f0] p-8" data-testid="quartier-points">
            <h2 className="font-logo font-black text-2xl">Louer à {q.name} en bref</h2>
            <ul className="mt-5 space-y-3">{q.points.map((p) => <li key={p} className="flex gap-3"><Check className="w-5 h-5 text-[#d9895a] shrink-0 mt-0.5" />{p}</li>)}</ul>
            <Link to={pricePath(q.city)} className="mt-6 inline-block font-bold text-[#d9895a] underline" data-testid="quartier-price-link">Voir les prix de la conciergerie à {q.city}</Link>
          </div>
        </Reveal>
      </section>

      <section className="py-16 bg-[#efe7d6]">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <h2 className="font-logo font-black text-3xl text-[#13261c]">Combien peut rapporter votre logement à {q.name} ?</h2>
          <div className="mt-6"><EstimateBar defaultCity={q.city} /></div>
        </div>
      </section>

      <CityFaq city={{ name: `${q.city} ${q.name}` }} base={quartierFaq(q)} />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20 flex flex-wrap gap-3 items-center">
        <CtaLink to="/rendez-vous" testid="quartier-cta-rdv">Prendre rendez-vous</CtaLink>
        {others.map((o) => <Link key={o.slug} to={quartierPath(o)} className="rounded-full ring-1 ring-[#e6dcc8] bg-white px-5 py-3 font-semibold text-[#13261c] hover:bg-[#13261c] hover:text-white transition-colors" data-testid={`quartier-link-${o.slug}`}>Conciergerie {o.name}</Link>)}
      </section>
      <FinalCta />
    </div>
  );
}
